import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "oidc-react";

import { SidebarProvider } from "@/components/ui/sidebar";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import ClassroomManagement from "@/components/ClassroomManagement";

const ClassroomManagementPage = () => {
  const auth = useAuth();
  const { courseName } = useParams();

  return (
    <SidebarProvider>
      <div className="min-h-screen w-full flex flex-col bg-gray-50">
        <Header />
        <div className="flex-1 flex">
          <Sidebar />
          <div className="flex-1 p-6 overflow-y-auto">
            <div className="max-w-5xl mx-auto w-full">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
                <div className="p-6">
                  <h1 className="text-2xl font-bold text-gray-900 mb-4">
                    Classroom Management
                  </h1>
                  <p className="text-gray-600">
                    Add and manage students for your course
                  </p>
                </div>
              </div>
              <ClassroomManagement />
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default ClassroomManagementPage;
